//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { get_account_information } from 'phoenix-session-helpers';
import Branding from 'branding';
import EventBus from 'event-bus';
import { applyVuetifyTheme } from 'helpers';
export default {
  props: {
    sessionId: {
      type: String,
      required: false
    },
    onClickLink: {
      type: Function,
      required: false
    },
    onClickBack: {
      type: Function,
      required: false
    },
    isFullWidth: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      error: null,
      loading: false,
      language: this.$lang.detect()
    };
  },
  async created() {
    var _this = this;
    this.$data.loading = true;
    try {
      if (this.$props.sessionId) {
        await this.tryToken(this.$props.sessionId);
      }
      if (!this.$session.user) {
        throw new Error('If your session is not initialized, you have to pass sessionId prop');
      }
      this.sync_branding_data();
      await this.post_sign_in_process();
      this.$data.loading = false;
    } catch (err) {
      await this.show_generic_error(err);
    }
    if (this.$props.onClickLink) {
      EventBus.$on('click:link', function () {
        _this.$props.onClickLink(...arguments);
      });
    }
    if (this.$props.onClickBack) {
      EventBus.$on('click:back', function () {
        _this.$props.onClickBack(...arguments);
      });
    }
  },
  methods: {
    async tryToken(tkn) {
      let token = tkn;
      try {
        this.$data.loading = true;
        if (token.startsWith('Bearer ')) token = token.slice(7).trim();
        await this.$session._load_user("Bearer ".concat(token), true);
        await this.post_sign_in_process();
      } catch (err) {
        await this.show_generic_error(err);
      }
      this.$data.loading = false;
    },
    async show_generic_error(err) {
      this.$data.error = this.$lang.t('app.generic-error', 'Something went wrong');
      console.log(err);
      this.$data.loading = false;
    },
    async post_sign_in_process() {
      if (this.$session.user) {
        this.$session.user.account = await get_account_information(this.$session, true);
      }
      this.sync_branding_data();
    },
    sync_branding_data() {
      const branding = new Branding(this.$session);
      Vue.prototype.$branding = branding;
      const {
        light
      } = branding.data.theme;
      applyVuetifyTheme(this.$vuetify, light, 'light');
    },
    alert_closed() {
      window.location.reload();
    },
    branding_exists() {
      return !!this.$branding;
    }
  }
};